module.exports = __webpack_public_path__ + "static/media/unlucky.b86d8d5a.mp3";